import { usePresentationContext } from '../../legacy-context/presentationContext';
import { LivePresentationDataHandler } from './LivePresentationDataHandler';
import {
  ViewOnlyPresentationDataHandler,
  type ViewOnlyPresentationDataHandlerProps,
} from './ViewOnlyPresentationDataHandler';

interface QuizChoicesPresentationDataHandlerProps {
  viewOnlyProps?: ViewOnlyPresentationDataHandlerProps;
}

type QuizChoicesPresentationDataHandler = (
  props: QuizChoicesPresentationDataHandlerProps,
) => JSX.Element;

export const QuizChoicesPresentationDataHandler: QuizChoicesPresentationDataHandler =
  ({ viewOnlyProps }) => {
    const { useConfig } = usePresentationContext();
    const { mode } = useConfig();

    if (mode !== 'live') {
      return <ViewOnlyPresentationDataHandler {...viewOnlyProps} />;
    }

    return <LivePresentationDataHandler />;
  };
